document.addEventListener("DOMContentLoaded", function() {
    try {
        if (window.location.pathname.indexOf('cart') >= 1 && productsWithAgeCheck && !customerIsLoggedIn && !useStrictVerify) {
            var cartToken = window.localStorage.cartToken.replace(/"/g, '');
            var button = document.getElementById('checkout');
            button.insertAdjacentHTML('afterEnd', '<a href="'+window.shopUrl+'/account/login?checkout_url='+window.shopUrl+'/checkouts/c/'+cartToken+'" class="shopify-challenge__button cart__checkout-button button" style="width:100%">Ausschecken</a>');
            button.style.display = 'none';

            var notification = document.querySelector('.cart__footer');
            notification.insertAdjacentHTML('afterEnd', '<p style="text-align:center;color:red">Ihr Warenkorb enthält FSK18-Artikel. Bevor Sie zum Checkout gelangen, müssen Sie sich registrieren und eine Altersprüfung durchführen.</p>');
        }
    } catch (e) {}
});

// If flyout cart is loaded
document.addEventListener("DOMNodeInserted", function() {
    try {
        if (productsWithAgeCheck && !customerIsLoggedIn && !useStrictVerify) {
            var cartToken = window.localStorage.cartToken.replace(/"/g, '');
            document.querySelector('button[name=checkout]').style.display = 'none';
        }

        if (productsWithAgeCheck && !customerIsLoggedIn && !useStrictVerify) {
            var stack = document.getElementsByClassName('shopify-payment-button');
            var key;
            for (key in stack) {
                stack[key].style.display = 'none';
            }
        }
    } catch (e) {}
});

// Check if customer must route to checkout
if (customerIsLoggedIn &&
    window.location.pathname.indexOf('account/register') < 1 &&
    window.location.pathname.indexOf('account/login') < 1 &&
    window.location.pathname.indexOf('cart') < 1
) {
    var fraspy_return_url = getCookieTlpxx('fraspy_return_url');
    if (fraspy_return_url != '') {
        $('body').hide();
        setCookieTlpxx('first_name', '', 0);
        setCookieTlpxx('last_name', '', 0);
        setCookieTlpxx('note_street', '', 0);
        setCookieTlpxx('note_zipcode', '', 0);
        setCookieTlpxx('note_city', '', 0);
        setCookieTlpxx('note_country', '', 0);
        setCookieTlpxx('note_birthday', '', 0);
        setCookieTlpxx('emailname', '', 0);
        self.location.href = './checkout';
    }
    setCookieTlpxx('fraspy_return_url', '', 0);
} else if (!customerIsLoggedIn &&
    window.location.pathname.indexOf('account/register') < 1 &&
    window.location.pathname.indexOf('account/login') < 1 &&
    window.location.pathname.indexOf('cart') < 1 &&
    window.location.pathname.indexOf('challenge') < 1
) {
    setCookieTlpxx('fraspy_return_url', '', 0);
}

function setCookieTlpxx(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookieTlpxx(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}